// import React, { useEffect, useRef, useState } from "react";
// import { Helmet } from 'react-helmet-async';
// import { Container } from "@mui/material";
// import ReactQuill from 'react-quill';
// import axios from "axios";
// import Swal from 'sweetalert2';
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";


// import { Url, awsFileUrl } from "../url/url";
// import 'react-quill/dist/quill.snow.css';
// import EditorToolbar, { modules, formats } from "../utils/EditorToolbar";
// import "../App.css"
// import { productdata } from "../redux/slice/product";


// const ageGroupOptions = ['0-12 months', '1-2 years', '3+ years', '5+ years', '10+ years'];

// const UpdateProduct = () => {
//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const { id } = useParams()
//     const categoryAllData = useSelector(store => store.category.data)
//     const subcategoryAllData = useSelector(store => store.subcategory.data)
//     const subcharacterAllData = useSelector(store => store.subcharacter.data)
//     const characterAllData = useSelector(store => store.character.data)
//     const productAllData = useSelector(store => store.product.data)
//     const [keyvalue, setKeyValue] = useState('');
//     const [specificationvalue, setSpecificationValue] = useState("");
//     const [otherValue, setOtherValue] = useState('');
//     const [descriptionValue, setDescriptionValue] = useState("");
//     const [loading, setLoading] = useState(false);
//     const [formValue, setFormValue] = useState({})
//     const [apiErr, setApiErr] = useState(false)


//     const [uploadLoading, setUploadLoading] = useState(false);
//     const [progressValue, setProgressValue] = useState(0);
//     const [uploadStatus, setUploadStatus] = useState(false);


//     const [multipleFileProgress, setMultipleFileProgress] = useState(0)
//     const [totalfiles, setTotalFiles] = useState(0)
//     const [totalUpload, setTotalUpload] = useState(0)
//     const [multipleFileStatus, setMultipleFileStatus] = useState(false)

//     const [progressVideoValue, setProgressVideoValue] = useState(0)

//     const [ageGroupSelectedOptions, setAgeGroupSelectedOptions] = useState([]);
//     const [ageGroupError, setAgeGroupError] = useState(false);
//     const errorRef = useRef(null);
// // formValue mein hi sab handle ho jayega, just checkbox ke liye ek state
// const [isLimitedEdition, setIsLimitedEdition] = useState(false);
//     const handleAgeGroupChange = (option) => {
//         setAgeGroupSelectedOptions((prev) =>
//             prev.includes(option)
//                 ? prev.filter((item) => item !== option) // Remove if already selected
//                 : [...prev, option] // Add if not selected
//         );
//     };


//     const formHandle = (e) => {
//         const name = e.target.name;
//         const value = e.target.value;
//         if (name === 'category') {
//             setFormValue({ ...formValue, 'subcategory': "" });
//         }
//         if (name === 'character') {
//             setFormValue({ ...formValue, 'subcharacter': "" });
//         }
//         setFormValue({ ...formValue, [name]: value });
//     }

//     const fileHandle = async (e) => {
//         const files = e.target.files;
//         const name = e.target.name;
//         const uploadedFiles = [];
//         setTotalFiles(files?.length);
//         setTotalUpload(0);
//         setMultipleFileProgress(0);
//         setMultipleFileStatus(true);
//         try {
//             await Array.from(files).reduce(async (previousPromise, file, i) => {
//                 await previousPromise;
//                 if (file) {
//                     const response = await axios.post(`${Url}/api/createPresignedUrl/products`, { fileName: file.name, fileType: file.type });
//                     if (response.status === 200) {
//                         const { preSignedUrl, key } = response?.data;
//                         const responseFileSave = await axios.put(preSignedUrl, file, {
//                             onUploadProgress: (progressEvent) => {
//                                 const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                                 setMultipleFileProgress(progress);
//                             },
//                         });

//                         if (responseFileSave.status === 200) {
//                             const fileUrl = `${awsFileUrl}/${key}`;
//                             setTotalUpload(i + 1);
//                             uploadedFiles.push(fileUrl);
//                         } else {
//                             throw new Error('File upload failed');
//                         }
//                     }
//                 }
//             }, Promise.resolve());
//             setFormValue({ ...formValue, [name]: uploadedFiles });
//             setMultipleFileStatus(false);
//             setUploadStatus(true);
//         } catch (error) {
//             console.log(error);
//         } finally {
//             setMultipleFileStatus(false);
//             setProgressValue(0);
//         }
//     };
//     const thumbnailHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         setUploadLoading(true)
//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products`, { fileName: file.name, fileType: file.type })
//                 if (response.status === 200) {
//                     const { preSignedUrl, key, fileType } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressValue(progress)
//                         },
//                     })
//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                         setUploadStatus(true)
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                     }
//                     else {
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                         setUploadStatus(false)
//                     }
//                     setUploadLoading(false)
//                 }
//                 setUploadLoading(false)
//             }
//         } catch (error) {
//             console.log(error);
//             setUploadLoading(false)
//         }
//         setUploadLoading(false)
//     }
//     const videoHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products/video`, { fileName: file.name, fileType: file.type })
//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressVideoValue(progress)
//                         },
//                     })
//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                     }
//                 }
//             }
//         } catch (error) {
//             console.log(error);
//         }
//     }

//     // const submit = async (e) => {
//     //     e.preventDefault()
//     //     setLoading(true)
//     //     if (ageGroupSelectedOptions.length === 0) {
//     //         setAgeGroupError(true);
//     //         errorRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
//     //         return;
//     //     }
//     //     if (descriptionValue) {
//     //         const dataValue = { ...formValue, "description": descriptionValue, "specification": specificationvalue, "keyFeature": keyvalue, "otherInfo": otherValue, ageGroup: ageGroupSelectedOptions }
//     //         try {
//     //             await axios.post(`${Url}/product/update/${id}`, dataValue).then((data) => {
//     //                 Swal.fire({
//     //                     position: 'top-end',
//     //                     icon: 'success',
//     //                     title: 'Add Product Success',
//     //                     showConfirmButton: false,
//     //                     timer: 1500
//     //                 })
//     //                 setLoading(false)
//     //                 dispatch(productdata())
//     //                 navigate("/dashboard/products")
//     //             })
//     //         } catch (error) {
//     //             Swal.fire({
//     //                 position: 'top-end',
//     //                 icon: 'error',
//     //                 title: "Something Went Wrong",
//     //                 showConfirmButton: false,
//     //                 timer: 1500
//     //             })
//     //             console.log(error.message);
//     //             setLoading(false)
//     //         }
//     //     }
//     //     else {
//     //         setLoading(false)
//     //         console.log("all fields are required ");
//     //         Swal.fire('All fields are required')
//     //     }

//     // }





// const submit = async (e) => {
//     e.preventDefault()
//     setLoading(true)
//     if (ageGroupSelectedOptions.length === 0) {
//         setAgeGroupError(true);
//         errorRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
//         setLoading(false); // ⭐ Add this
//         return;
//     }
//     if (descriptionValue) {
//         const dataValue = { 
//             ...formValue, 
//             "description": descriptionValue, 
//             "specification": specificationvalue, 
//             "keyFeature": keyvalue, 
//             "otherInfo": otherValue, 
//             ageGroup: ageGroupSelectedOptions,
//             limitedEdition: isLimitedEdition // ⭐ Add this
//         }
        
//         try {
//             await axios.post(`${Url}/product/update/${id}`, dataValue).then((data) => {
//                 Swal.fire({
//                     position: 'top-end',
//                     icon: 'success',
//                     title: 'Product Updated Successfully', // ⭐ Changed message
//                     showConfirmButton: false,
//                     timer: 1500
//                 })
//                 setLoading(false)
//                 dispatch(productdata())
//                 navigate("/dashboard/products")
//             })
//         } catch (error) {
//             Swal.fire({
//                 position: 'top-end',
//                 icon: 'error',
//                 title: "Something Went Wrong",
//                 showConfirmButton: false,
//                 timer: 1500
//             })
//             console.log(error.message);
//             setLoading(false)
//         }
//     }
//     else {
//         setLoading(false)
//         console.log("all fields are required ");
//         Swal.fire('All fields are required')
//     }
// }



//     // const editDataFilter = async () => {

//     //     try {
//     //         const productResponse = await axios.get(`${Url}/product/single-product/${id}`)
//     //         if (productResponse.status === 200) {
//     //             const response = productResponse.data
//     //             setFormValue({ ...response, ...response?.productSize })
//     //             setSpecificationValue(response.specification)
//     //             setOtherValue(response.otherInfo)
//     //             setDescriptionValue(response.description)
//     //             setKeyValue(response.keyFeature)
//     //             setAgeGroupSelectedOptions(response.ageGroup)
//     //         }
//     //     } catch (error) {
//     //         console.log(error);
//     //         setApiErr(true)
//     //     }

//     // }
// const editDataFilter = async () => {
//     try {
//         const productResponse = await axios.get(`${Url}/product/single-product/${id}`)
//         if (productResponse.status === 200) {
//             const response = productResponse.data
//             setFormValue({ ...response, ...response?.productSize })
//             setSpecificationValue(response.specification)
//             setOtherValue(response.otherInfo)
//             setDescriptionValue(response.description)
//             setKeyValue(response.keyFeature)
//             setAgeGroupSelectedOptions(response.ageGroup)
//             setIsLimitedEdition(response.limitedEdition || false) // ⭐ Add this
//         }
//     } catch (error) {
//         console.log(error);
//         setApiErr(true)
//     }
// }

//     useEffect(() => {
//         editDataFilter()
//     }, [id])


    
//     return (
//         <>
//             <Helmet>
//                 <title> Update Product </title>
//             </Helmet>


//             <Container>
//                 <div className="mb-4 text-primary">
//                     <h2 className="text-capitalize">Update product new</h2>
//                 </div>
//                 {productAllData && formValue ?
//                     <div className="p-3 bg-light rounded shadow border">
//                         <form action="" onSubmit={e => submit(e)}>
//                             <div className="row">
//                        <div className="col-12 mb-2">
//     <div className="form-group">
//         <p className="mb-0 fw-bold">Product Name</p>
//         <input type="text" value={formValue.productName} name="productName" onChange={e => formHandle(e)} className="form-control" required />
//     </div>
// </div>

// {/* ⭐ Add Seller Name field */}

//    <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Seller Name</p>
//                                     <select
//                                         name="sellerName"
//                                         value={formValue.sellerName || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-select"
//                                         required
//                                     >
//                                         <option value="" disabled>Choose Seller</option>
//                                         <option value="Devi Shera">Devi Shera</option>
//                                         <option value="Doozie-do">Doozie-do</option>
//                                     </select>
//                                 </div>
//                             </div>

// {/* ⭐ Add Limited Edition checkbox */}
// <div className="col-lg-6 col-12 mb-2">
//     <div className="form-group">
//         <p className="mb-0 fw-bold">Limited Edition</p>
//         <div className="form-check mt-1">
//             <input
//                 type="checkbox"
//                 className="form-check-input"
//                 id="limitedEditionUpdate"
//                 checked={isLimitedEdition}
//                 onChange={(e) => setIsLimitedEdition(e.target.checked)}
//             />
//             <span className="form-check-label ms-2">
//                 Mark as Limited Edition
//             </span>
//         </div>
//     </div>
// </div>

// {/* Continue with Short Description... */}
// <div className="col-12 mb-2">
//     <div className="form-group">
//         <p className="mb-0 fw-bold">short Description</p>
//         <textarea className="form-control" value={formValue.shortDescription} name="shortDescription" onChange={e => formHandle(e)} rows="3" required />
//     </div>
// </div>
//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">short Description</p>
//                                         <textarea className="form-control" value={formValue.shortDescription} name="shortDescription" onChange={e => formHandle(e)} rows="3" required />
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-6 col-12 mb-4">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Thumbnail Image</p>
//                                         <input type="file" name="thumbnailImage" onChange={e => thumbnailHandle(e)} className="form-control" />
//                                         <div className="d-flex justify-content-end gap-2 pt-2">
//                                             {uploadLoading && progressValue && <progress className="flex-grow-1" value={progressValue} max="100" style={{ height: "5px" }} />}
//                                             {/* {uploadStatus && <small className="fs-10 text-success">{uploadLoading ? `${progressValue} %` : 'success'} </small>}  */}
//                                         </div>
//                                     </div>
//                                     <div className="mt-2">
//                                         {/* <img src={`${oldThumbnailImage}`} alt="" style={{width: "100px"}} className="border rounded" />  */}
//                                         <img src={`${formValue?.thumbnailImage}`} alt="" style={{ width: "70px" }} className="border rounded" />
//                                     </div>
//                                 </div>



//                                 <div className="col-lg-6 col-12 mb-4">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Product Images</p>
//                                         <input type="file" name="images" multiple onChange={e => fileHandle(e)} className="form-control" />
//                                         {totalfiles !== 0 &&
//                                             <div className="d-flex justify-content-end gap-2 pt-2 align-items-center">
//                                                 <progress className="flex-grow-1 " value={(totalUpload / totalfiles) * 100} max="100" style={{ height: "5px" }} />

//                                                 <small className="fs-10 text-secondary w-max-content">{totalUpload}/{totalfiles}  </small>
//                                                 <small className="fs-10 text-success w-max-content">{((totalUpload / totalfiles) * 100).toFixed(1)} % </small>

//                                             </div>}
//                                     </div>
//                                     <div className="mt-2 d-flex flex-wrap gap-3">
//                                         {formValue?.images?.map((cv, i) => {
//                                             return (
//                                                 <img key={i} src={`${cv}`} alt="" style={{ width: "70px" }} className="border rounded me-1 mb-1" />
//                                             )
//                                         })}
//                                     </div>
//                                 </div>


//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Product Video <span className="fw-normal text-secondary"> (optional) </span> </p>
//                                         <input type="file" name="video" accept="video/*" onChange={e => videoHandle(e)} className="form-control" />

//                                         {/* <div className="d-flex justify-content-end gap-2 pt-2">
//                                             {progressVideoValue > 0 && progressVideoValue < 100 && <progress className="flex-grow-1" value={progressVideoValue} max="100" style={{ height: "5px" }} />}

//                                             {progressVideoValue > 0 && <small className="fs-10 text-success">{progressVideoValue < 100 ? `${progressVideoValue} %` : 'success'} </small>}

//                                         </div> */}
//                                     </div>
//                                     <div className="mt-2">
//                                         <video src={formValue?.video} controls muted width={150} />
//                                         {/* <img src={`${formValue?.thumbnailImage}`} alt="" style={{ width: "70px" }} className="border rounded" /> */}
//                                     </div>

//                                 </div>


//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Image alt tag</p>
//                                         <input type="text" value={formValue.altTag} name="altTag" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-6 col-12">
//                                     <div className="row">
//                                         <div className="col-lg-4  mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">MRP (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
//                                                 <input type="number" value={formValue.mrp} name="mrp" onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-4 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Sale Price (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
//                                                 <input type="number" value={formValue.salePrice} name="salePrice" onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-4 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Discount (%)</p>
//                                                 <input type="number" value={formValue.discount} name="discount" onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>


//                                 {/* <div className="col-lg-6 col-12">
//                                     <div className="row">
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Height</p>
//                                                 <input type="text" name="height" value={height} onChange={e => setHeight(e.target.value)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Width</p>
//                                                 <input type="text" name="width" value={width} onChange={e => setWidth(e.target.value)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Depth</p>
//                                                 <input type="text" name="depth" value={depth} onChange={e => setDepth(e.target.value)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">size</p>
//                                                 <select name="measurement" onChange={e => setMeasurement(e.target.value)} value={measurement} id="" className="form-select" required>
//                                                     <option value="">choose</option>
//                                                     <option value={"cm"} >cm</option>
//                                                     <option value={"inch"} >inch</option>
//                                                 </select>
//                                             </div>
//                                         </div>

//                                     </div>
//                                 </div> */}
//                                 <div className="col-lg-6 col-12">
//                                     <div className="row">
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Height</p>
//                                                 <input type="text" name="height" value={formValue?.height} onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Width</p>
//                                                 <input type="text" name="width" value={formValue?.width} onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Depth</p>
//                                                 <input type="text" name="depth" value={formValue?.depth} onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">size</p>
//                                                 <select name="measurement" onChange={e => formHandle(e)} value={formValue?.measurement} className="form-select" required>
//                                                     <option value="">choose</option>
//                                                     <option value={"cm"} >cm</option>
//                                                     <option value={"inch"} >inch</option>
//                                                 </select>
//                                             </div>
//                                         </div>

//                                     </div>
//                                 </div>
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Total Product</p>
//                                         <input type="number" value={formValue.totalProduct} name="totalProduct" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Category</p>
//                                         <select name="category" value={formValue.category} onChange={e => formHandle(e)} className="form-select" required>
//                                             <option value='' disabled={(formValue.category)}>Category Choose</option>
//                                             {categoryAllData.map((cv, i) => {
//                                                 return (
//                                                     <option value={cv.category} key={i}>{cv.category}</option>
//                                                 )
//                                             })}
//                                         </select>
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Sub Category</p>
//                                         <select name="subcategory" value={formValue.subcategory} onChange={e => formHandle(e)} className="form-select" required>
//                                             <option value='' > Choose</option>
//                                             {subcategoryAllData.filter(val => val.category === formValue.category).map((value, i) => {
//                                                 return (
//                                                     <option value={value.subcategory} key={i}>{value.subcategory}</option>
//                                                 )
//                                             })}
//                                         </select>
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Character</p>
//                                         <select name="character" value={formValue.character} onChange={e => formHandle(e)} id="" className="form-select" required>
//                                             <option value='' disabled={(formValue.character)} >Character Choose</option>
//                                             {characterAllData.map((cv, i) => {
//                                                 return (
//                                                     <option value={cv.character} key={i}>{cv.character}</option>
//                                                 )
//                                             })}
//                                         </select>
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Sub Character</p>
//                                         <select name="subcharacter" value={formValue.subcharacter} onChange={e => formHandle(e)} className="form-select" required>
//                                             <option value='' > Choose</option>
//                                             {formValue.character && subcharacterAllData.filter(val => val.character === formValue.character).map((value, i) => {
//                                                 return (
//                                                     <option value={value.subcharacter} key={i}>{value.subcharacter}</option>
//                                                 )
//                                             })}
//                                         </select>
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Batch No.</p>
//                                         <input type="text" value={formValue.batch} name="batch" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">SKU No.</p>
//                                         <input type="text" value={formValue.sku} name="sku" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Replacement (days)</p>
//                                         <input type="number" name="replacement" value={formValue.replacement} onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>


//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Product Weight (gm)</p>
//                                         <input type="number" name="weight" value={formValue.weight} onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Choose Tags</p>
//                                         <select name="tags" value={formValue.tags ? formValue.tags : ""} onChange={e => formHandle(e)} className="form-select" >
//                                             <option value="">Choose Any Tag</option>
//                                             <option value="top picks">Top Picks</option>
//                                             <option value="new arrival">New Arrival</option>
//                                         </select>
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <p className="mb-0 fw-bold">Choose Product Age Group</p>
//                                     {ageGroupError && (
//                                         <p ref={errorRef} className="text-danger fw-normal mb-1">
//                                             Please select at least one option!
//                                         </p>
//                                     )}
//                                     {ageGroupOptions.map((option, index) => (
//                                         <div key={index} className="form-check">
//                                             <input
//                                                 type="checkbox"
//                                                 id={option}
//                                                 checked={ageGroupSelectedOptions.includes(option)}
//                                                 onChange={() => handleAgeGroupChange(option)}
//                                                 className="form-check-input"
//                                             />
//                                             <label htmlFor={option} className="form-check-label">
//                                                 {option}
//                                             </label>
//                                         </div>
//                                     ))}
//                                 </div>









//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Descrption</p>
//                                         <div className="text-editor bg-white rounded">
//                                             <ReactQuill theme="snow" value={descriptionValue} onChange={setDescriptionValue} placeholder={"Write something awesome..."} />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">key features</p>
//                                         <div className="text-editor bg-white">
//                                             <EditorToolbar />
//                                             <ReactQuill theme="snow" value={keyvalue} onChange={setKeyValue} placeholder={"Write something awesome..."} modules={modules} formats={formats} />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Specification</p>
//                                         <div className="text-editor bg-white">
//                                             <ReactQuill theme="snow" value={specificationvalue} onChange={setSpecificationValue} placeholder={"Write something awesome..."} />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Other Info</p>
//                                         <div className="text-editor bg-white">
//                                             <ReactQuill theme="snow" name="other_info" value={otherValue} onChange={setOtherValue} placeholder={"Write something awesome..."} />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="col-12 ">
//                                     <div className="form-group text-end">
//                                         <button className="btn btn-primary " type="submit" disabled={loading || apiErr}>{loading ? "saving..." : "Post"}</button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </form>
//                     </div>
//                     : null}
//             </Container>
//         </>
//     )
// }

// export default UpdateProduct









// import React, { useEffect, useRef, useState } from "react";
// import { Helmet } from 'react-helmet-async';
// import { Container } from "@mui/material";
// import ReactQuill from 'react-quill';
// import axios from "axios";
// import Swal from 'sweetalert2';
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";

// import { Url, awsFileUrl } from "../url/url";
// import 'react-quill/dist/quill.snow.css';
// import EditorToolbar, { modules, formats } from "../utils/EditorToolbar";
// import "../App.css"
// import { productdata } from "../redux/slice/product";

// const ageGroupOptions = ['0-12 months', '1-2 years', '3+ years', '5+ years', '10+ years'];

// const UpdateProduct = () => {
//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const { id } = useParams()
//     const categoryAllData = useSelector(store => store.category.data)
//     const subcategoryAllData = useSelector(store => store.subcategory.data)
//     const subcharacterAllData = useSelector(store => store.subcharacter.data)
//     const characterAllData = useSelector(store => store.character.data)
//     const productAllData = useSelector(store => store.product.data)
//     const [keyvalue, setKeyValue] = useState('');
//     const [specificationvalue, setSpecificationValue] = useState("");
//     const [otherValue, setOtherValue] = useState('');
//     const [descriptionValue, setDescriptionValue] = useState("");
//     const [loading, setLoading] = useState(false);
//     const [formValue, setFormValue] = useState({})
//     const [apiErr, setApiErr] = useState(false)

//     const [uploadLoading, setUploadLoading] = useState(false);
//     const [progressValue, setProgressValue] = useState(0);
//     const [uploadStatus, setUploadStatus] = useState(false);

//     const [multipleFileProgress, setMultipleFileProgress] = useState(0)
//     const [totalfiles, setTotalFiles] = useState(0)
//     const [totalUpload, setTotalUpload] = useState(0)
//     const [multipleFileStatus, setMultipleFileStatus] = useState(false)

//     const [progressVideoValue, setProgressVideoValue] = useState(0)

//     const [ageGroupSelectedOptions, setAgeGroupSelectedOptions] = useState([]);
//     const [ageGroupError, setAgeGroupError] = useState(false);
//     const errorRef = useRef(null);
//     const [isLimitedEdition, setIsLimitedEdition] = useState(false);

//     const handleAgeGroupChange = (option) => {
//         setAgeGroupSelectedOptions((prev) =>
//             prev.includes(option)
//                 ? prev.filter((item) => item !== option)
//                 : [...prev, option]
//         );
//     };

//     // ⭐ ONLY THIS FUNCTION CHANGED - Rest all same
//     const formHandle = (e) => {
//         const name = e.target.name;
//         const value = e.target.value;
//         if (name === 'category') {
//             setFormValue({ ...formValue, 'subcategory': "", [name]: value });
//         }
//         else if (name === 'character') {
//             setFormValue({ ...formValue, 'subcharacter': "", [name]: value });
//         }
//         else {
//             setFormValue({ ...formValue, [name]: value });
//         }
//     }

//     const fileHandle = async (e) => {
//         const files = e.target.files;
//         const name = e.target.name;
//         const uploadedFiles = [];
//         setTotalFiles(files?.length);
//         setTotalUpload(0);
//         setMultipleFileProgress(0);
//         setMultipleFileStatus(true);
//         try {
//             await Array.from(files).reduce(async (previousPromise, file, i) => {
//                 await previousPromise;
//                 if (file) {
//                     const response = await axios.post(`${Url}/api/createPresignedUrl/products`, { fileName: file.name, fileType: file.type });
//                     if (response.status === 200) {
//                         const { preSignedUrl, key } = response?.data;
//                         const responseFileSave = await axios.put(preSignedUrl, file, {
//                             onUploadProgress: (progressEvent) => {
//                                 const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                                 setMultipleFileProgress(progress);
//                             },
//                         });

//                         if (responseFileSave.status === 200) {
//                             const fileUrl = `${awsFileUrl}/${key}`;
//                             setTotalUpload(i + 1);
//                             uploadedFiles.push(fileUrl);
//                         } else {
//                             throw new Error('File upload failed');
//                         }
//                     }
//                 }
//             }, Promise.resolve());
//             setFormValue({ ...formValue, [name]: uploadedFiles });
//             setMultipleFileStatus(false);
//             setUploadStatus(true);
//         } catch (error) {
//             console.log(error);
//         } finally {
//             setMultipleFileStatus(false);
//             setProgressValue(0);
//         }
//     };

//     const thumbnailHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         setUploadLoading(true)
//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products`, { fileName: file.name, fileType: file.type })
//                 if (response.status === 200) {
//                     const { preSignedUrl, key, fileType } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressValue(progress)
//                         },
//                     })
//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                         setUploadStatus(true)
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                     }
//                     else {
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                         setUploadStatus(false)
//                     }
//                     setUploadLoading(false)
//                 }
//                 setUploadLoading(false)
//             }
//         } catch (error) {
//             console.log(error);
//             setUploadLoading(false)
//         }
//         setUploadLoading(false)
//     }

//     const videoHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products/video`, { fileName: file.name, fileType: file.type })
//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressVideoValue(progress)
//                         },
//                     })
//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                     }
//                 }
//             }
//         } catch (error) {
//             console.log(error);
//         }
//     }

//     const submit = async (e) => {
//         e.preventDefault()
//         setLoading(true)
//         if (ageGroupSelectedOptions.length === 0) {
//             setAgeGroupError(true);
//             errorRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
//             setLoading(false);
//             return;
//         }
//         if (descriptionValue) {
//             const dataValue = { 
//                 ...formValue, 
//                 "description": descriptionValue, 
//                 "specification": specificationvalue, 
//                 "keyFeature": keyvalue, 
//                 "otherInfo": otherValue, 
//                 ageGroup: ageGroupSelectedOptions,
//                 limitedEdition: isLimitedEdition
//             }
            
//             try {
//                 await axios.post(`${Url}/product/update/${id}`, dataValue).then((data) => {
//                     Swal.fire({
//                         position: 'top-end',
//                         icon: 'success',
//                         title: 'Product Updated Successfully',
//                         showConfirmButton: false,
//                         timer: 1500
//                     })
//                     setLoading(false)
//                     dispatch(productdata())
//                     navigate("/dashboard/products")
//                 })
//             } catch (error) {
//                 Swal.fire({
//                     position: 'top-end',
//                     icon: 'error',
//                     title: "Something Went Wrong",
//                     showConfirmButton: false,
//                     timer: 1500
//                 })
//                 console.log(error.message);
//                 setLoading(false)
//             }
//         }
//         else {
//             setLoading(false)
//             console.log("all fields are required ");
//             Swal.fire('All fields are required')
//         }
//     }

//     const editDataFilter = async () => {
//         try {
//             const productResponse = await axios.get(`${Url}/product/single-product/${id}`)
//             console.log("productResponse", productResponse)
//             if (productResponse.status === 200) {
//                 const response = productResponse.data
//                 setFormValue({ ...response, ...response?.productSize })
//                 setSpecificationValue(response.specification)
//                 setOtherValue(response.otherInfo)
//                 setDescriptionValue(response.description)
//                 setKeyValue(response.keyFeature)
//                 setAgeGroupSelectedOptions(response.ageGroup)
//                 setIsLimitedEdition(response.limitedEdition || false)
//             }
//         } catch (error) {
//             console.log(error);
//             setApiErr(true)
//         }
//     }

//     useEffect(() => {
//         editDataFilter()
//     }, [id])

//     // ⭐ Debug ke liye - ye dekhne ke liye ki data aa raha hai ya nahi
//     useEffect(() => {
//         console.log("formValue.subcategory:", formValue.subcategory);
//         console.log("formValue.category:", formValue.category);
//         console.log("All subcategories:", subcategoryAllData);
//     }, [formValue])

//     return (
//         <>
//             <Helmet>
//                 <title> Update Product </title>
//             </Helmet>

//             <Container>
//                 <div className="mb-4 text-primary">
//                     <h2 className="text-capitalize">Update product new</h2>
//                 </div>
//                 {productAllData && formValue ?
//                     <div className="p-3 bg-light rounded shadow border">
//                         <form action="" onSubmit={e => submit(e)}>
//                             <div className="row">
//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Product Name</p>
//                                         <input type="text" value={formValue.productName} name="productName" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>

//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Seller Name</p>
//                                         <select
//                                             name="sellerName"
//                                             value={formValue.sellerName || ""}
//                                             onChange={e => formHandle(e)}
//                                             className="form-select"
//                                             required
//                                         >
//                                             <option value="" disabled>Choose Seller</option>
//                                             <option value="Devi Shera">Devi Shera</option>
//                                             <option value="Doozie-do">Doozie-do</option>
//                                         </select>
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Limited Edition</p>
//                                         <div className="form-check mt-1">
//                                             <input
//                                                 type="checkbox"
//                                                 className="form-check-input"
//                                                 id="limitedEditionUpdate"
//                                                 checked={isLimitedEdition}
//                                                 onChange={(e) => setIsLimitedEdition(e.target.checked)}
//                                             />
//                                             <span className="form-check-label ms-2">
//                                                 Mark as Limited Edition
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">short Description</p>
//                                         <textarea className="form-control" value={formValue.shortDescription} name="shortDescription" onChange={e => formHandle(e)} rows="3" required />
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-4">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Thumbnail Image</p>
//                                         <input type="file" name="thumbnailImage" onChange={e => thumbnailHandle(e)} className="form-control" />
//                                         <div className="d-flex justify-content-end gap-2 pt-2">
//                                             {uploadLoading && progressValue && <progress className="flex-grow-1" value={progressValue} max="100" style={{ height: "5px" }} />}
//                                         </div>
//                                     </div>
//                                     <div className="mt-2">
//                                         <img src={`${formValue?.thumbnailImage}`} alt="" style={{ width: "70px" }} className="border rounded" />
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-4">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Product Images</p>
//                                         <input type="file" name="images" multiple onChange={e => fileHandle(e)} className="form-control" />
//                                         {totalfiles !== 0 &&
//                                             <div className="d-flex justify-content-end gap-2 pt-2 align-items-center">
//                                                 <progress className="flex-grow-1 " value={(totalUpload / totalfiles) * 100} max="100" style={{ height: "5px" }} />
//                                                 <small className="fs-10 text-secondary w-max-content">{totalUpload}/{totalfiles}  </small>
//                                                 <small className="fs-10 text-success w-max-content">{((totalUpload / totalfiles) * 100).toFixed(1)} % </small>
//                                             </div>}
//                                     </div>
//                                     <div className="mt-2 d-flex flex-wrap gap-3">
//                                         {formValue?.images?.map((cv, i) => {
//                                             return (
//                                                 <img key={i} src={`${cv}`} alt="" style={{ width: "70px" }} className="border rounded me-1 mb-1" />
//                                             )
//                                         })}
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Product Video <span className="fw-normal text-secondary"> (optional) </span> </p>
//                                         <input type="file" name="video" accept="video/*" onChange={e => videoHandle(e)} className="form-control" />
//                                     </div>
//                                     <div className="mt-2">
//                                         <video src={formValue?.video} controls muted width={150} />
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Image alt tag</p>
//                                         <input type="text" value={formValue.altTag} name="altTag" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12">
//                                     <div className="row">
//                                         <div className="col-lg-4  mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">MRP (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
//                                                 <input type="number" value={formValue.mrp} name="mrp" onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-4 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Sale Price (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
//                                                 <input type="number" value={formValue.salePrice} name="salePrice" onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-4 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Discount (%)</p>
//                                                 <input type="number" value={formValue.discount} name="discount" onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12">
//                                     <div className="row">
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Height</p>
//                                                 <input type="text" name="height" value={formValue?.height} onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Width</p>
//                                                 <input type="text" name="width" value={formValue?.width} onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Depth</p>
//                                                 <input type="text" name="depth" value={formValue?.depth} onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">size</p>
//                                                 <select name="measurement" onChange={e => formHandle(e)} value={formValue?.measurement} className="form-select" required>
//                                                     <option value="">choose</option>
//                                                     <option value={"cm"} >cm</option>
//                                                     <option value={"inch"} >inch</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Total Product</p>
//                                         <input type="number" value={formValue.totalProduct} name="totalProduct" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Category</p>
//                                         <select name="category" value={formValue.category} onChange={e => formHandle(e)} className="form-select" required>
//                                             <option value='' disabled={(formValue.category)}>Category Choose</option>
//                                             {categoryAllData.map((cv, i) => {
//                                                 return (
//                                                     <option value={cv.category} key={i}>{cv.category}</option>
//                                                 )
//                                             })}
//                                         </select>
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Sub Category</p>
//                                         <select 
//                                             name="subcategory" 
//                                             value={formValue?.subcategory || ""} 
//                                             onChange={e => formHandle(e)} 
//                                             className="form-select" 
//                                             required
//                                         >
//                                             <option value=''>Choose</option>
//                                             {formValue?.category && subcategoryAllData
//                                                 .filter(val => val.category === formValue.category)
//                                                 .map((value, i) => (
//                                                     <option value={value.subcategory} key={i}>
//                                                         {value.subcategory}
//                                                     </option>
//                                                 ))
//                                             }
//                                         </select>
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Character</p>
//                                         <select name="character" value={formValue.character} onChange={e => formHandle(e)} id="" className="form-select" required>
//                                             <option value='' disabled={(formValue.character)} >Character Choose</option>
//                                             {characterAllData.map((cv, i) => {
//                                                 return (
//                                                     <option value={cv.character} key={i}>{cv.character}</option>
//                                                 )
//                                             })}
//                                         </select>
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Sub Character</p>
//                                         <select name="subcharacter" value={formValue.subcharacter} onChange={e => formHandle(e)} className="form-select" required>
//                                             <option value='' > Choose</option>
//                                             {formValue.character && subcharacterAllData.filter(val => val.character === formValue.character).map((value, i) => {
//                                                 return (
//                                                     <option value={value.subcharacter} key={i}>{value.subcharacter}</option>
//                                                 )
//                                             })}
//                                         </select>
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Batch No.</p>
//                                         <input type="text" value={formValue.batch} name="batch" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">SKU No.</p>
//                                         <input type="text" value={formValue.sku} name="sku" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Replacement (days)</p>
//                                         <input type="number" name="replacement" value={formValue.replacement} onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Product Weight (gm)</p>
//                                         <input type="number" name="weight" value={formValue.weight} onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Choose Tags</p>
//                                         <select name="tags" value={formValue.tags ? formValue.tags : ""} onChange={e => formHandle(e)} className="form-select" >
//                                             <option value="">Choose Any Tag</option>
//                                             <option value="top picks">Top Picks</option>
//                                             <option value="new arrival">New Arrival</option>
//                                         </select>
//                                     </div>
//                                 </div>

//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <p className="mb-0 fw-bold">Choose Product Age Group</p>
//                                     {ageGroupError && (
//                                         <p ref={errorRef} className="text-danger fw-normal mb-1">
//                                             Please select at least one option!
//                                         </p>
//                                     )}
//                                     {ageGroupOptions.map((option, index) => (
//                                         <div key={index} className="form-check">
//                                             <input
//                                                 type="checkbox"
//                                                 id={option}
//                                                 checked={ageGroupSelectedOptions.includes(option)}
//                                                 onChange={() => handleAgeGroupChange(option)}
//                                                 className="form-check-input"
//                                             />
//                                             <label htmlFor={option} className="form-check-label">
//                                                 {option}
//                                             </label>
//                                         </div>
//                                     ))}
//                                 </div>

//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Descrption</p>
//                                         <div className="text-editor bg-white rounded">
//                                             <ReactQuill theme="snow" value={descriptionValue} onChange={setDescriptionValue} placeholder={"Write something awesome..."} />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">key features</p>
//                                         <div className="text-editor bg-white">
//                                             <EditorToolbar />
//                                             <ReactQuill theme="snow" value={keyvalue} onChange={setKeyValue} placeholder={"Write something awesome..."} modules={modules} formats={formats} />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Specification</p>
//                                         <div className="text-editor bg-white">
//                                             <ReactQuill theme="snow" value={specificationvalue} onChange={setSpecificationValue} placeholder={"Write something awesome..."} />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Other Info</p>
//                                         <div className="text-editor bg-white">
//                                             <ReactQuill theme="snow" name="other_info" value={otherValue} onChange={setOtherValue} placeholder={"Write something awesome..."} />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="col-12 ">
//                                     <div className="form-group text-end">
//                                         <button className="btn btn-primary " type="submit" disabled={loading || apiErr}>{loading ? "saving..." : "Post"}</button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </form>
//                     </div>
//                     : null}
//             </Container>
//         </>
//     )
// }

// export default UpdateProduct










// import React, { useEffect, useRef, useState } from "react";
// import { Helmet } from 'react-helmet-async';
// import { Container } from "@mui/material";
// import ReactQuill from 'react-quill';
// import axios from "axios";
// import Swal from 'sweetalert2';
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";

// import { Url, awsFileUrl } from "../url/url";
// import 'react-quill/dist/quill.snow.css';
// import EditorToolbar, { modules, formats } from "../utils/EditorToolbar";
// import "../App.css"
// import { productdata } from "../redux/slice/product";

// const ageGroupOptions = ['0-12 months', '1-2 years', '3+ years', '5+ years', '10+ years'];

// const UpdateProduct = () => {
//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const { id } = useParams()
//     const categoryAllData = useSelector(store => store.category.data)
//     const subcategoryAllData = useSelector(store => store.subcategory.data)
//     const productAllData = useSelector(store => store.product.data)
// console.log("productAllData",productAllData)
//     const [keyvalue, setKeyValue] = useState('');
//     const [specificationvalue, setSpecificationValue] = useState("");
//     const [otherValue, setOtherValue] = useState('');
//     const [descriptionValue, setDescriptionValue] = useState("");
//     const [loading, setLoading] = useState(false);
//     const [formValue, setFormValue] = useState({})
//     const [apiErr, setApiErr] = useState(false)

//     const [salePriceValue, setSalePriceValue] = useState('');

//     const [uploadLoading, setUploadLoading] = useState(false);
//     const [progressValue, setProgressValue] = useState(0);
//     const [uploadStatus, setUploadStatus] = useState(false);

//     const [multipleFileProgress, setMultipleFileProgress] = useState(0)
//     const [totalfiles, setTotalFiles] = useState(0)
//     const [totalUpload, setTotalUpload] = useState(0)
//     const [multipleFileStatus, setMultipleFileStatus] = useState(false)

//     const [progressVideoValue, setProgressVideoValue] = useState(0)

//     const [ageGroupSelectedOptions, setAgeGroupSelectedOptions] = useState([]);
//     const [ageGroupError, setAgeGroupError] = useState(false);
//     const errorRef = useRef(null);
//     const [isLimitedEdition, setIsLimitedEdition] = useState(false);

//     const handleAgeGroupChange = (option) => {
//         setAgeGroupSelectedOptions((prev) =>
//             prev.includes(option)
//                 ? prev.filter((item) => item !== option)
//                 : [...prev, option]
//         );
//     };

//     const formHandle = (e) => {
//         const name = e.target.name;
//         const value = e.target.value;
//         if (name === 'category') {
//             setFormValue({ ...formValue, subcategory: "", [name]: value });
//         } else {
//             setFormValue({ ...formValue, [name]: value });
//         }
//     }

//     // MRP ya Discount change hone par Sale Price auto-calculate
//     const handleMrpOrDiscount = (e) => {
//         const name = e.target.name;
//         const value = e.target.value;
//         const updated = { ...formValue, [name]: value };
//         setFormValue(updated);

//         const mrp = parseFloat(name === 'mrp' ? value : updated.mrp) || 0;
//         const discountRaw = name === 'discount' ? value : updated.discount;
//         const discount = parseFloat(discountRaw);

//         if (!discountRaw || discountRaw === '' || Number.isNaN(discount) || discount <= 0) {
//             setSalePriceValue('');
//             setFormValue({ ...updated, salePrice: updated.salePrice || '' });
//             return;
//         }

//         if (mrp > 0) {
//             const calculated = String(Math.round(mrp - (mrp * discount) / 100));
//             setSalePriceValue(calculated);
//             setFormValue({ ...updated, salePrice: calculated });
//         }
//     };

//     const fileHandle = async (e) => {
//         const files = e.target.files;
//         const name = e.target.name;
//         const uploadedFiles = [];
//         setTotalFiles(files?.length);
//         setTotalUpload(0);
//         setMultipleFileProgress(0);
//         setMultipleFileStatus(true);
//         try {
//             await Array.from(files).reduce(async (previousPromise, file, i) => {
//                 await previousPromise;
//                 if (file) {
//                     const response = await axios.post(`${Url}/api/createPresignedUrl/products`, { fileName: file.name, fileType: file.type });
//                     if (response.status === 200) {
//                         const { preSignedUrl, key } = response?.data;
//                         const responseFileSave = await axios.put(preSignedUrl, file, {
//                             onUploadProgress: (progressEvent) => {
//                                 const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                                 setMultipleFileProgress(progress);
//                             },
//                         });
//                         if (responseFileSave.status === 200) {
//                             const fileUrl = `${awsFileUrl}/${key}`;
//                             setTotalUpload(i + 1);
//                             uploadedFiles.push(fileUrl);
//                         } else {
//                             throw new Error('File upload failed');
//                         }
//                     }
//                 }
//             }, Promise.resolve());
//             setFormValue({ ...formValue, [name]: uploadedFiles });
//             setMultipleFileStatus(false);
//             setUploadStatus(true);
//         } catch (error) {
//             console.log(error);
//         } finally {
//             setMultipleFileStatus(false);
//             setProgressValue(0);
//         }
//     };

//     const thumbnailHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         setUploadLoading(true)
//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products`, { fileName: file.name, fileType: file.type })
//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressValue(progress)
//                         },
//                     })
//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                         setUploadStatus(true)
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                     } else {
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                         setUploadStatus(false)
//                     }
//                     setUploadLoading(false)
//                 }
//                 setUploadLoading(false)
//             }
//         } catch (error) {
//             console.log(error);
//             setUploadLoading(false)
//         }
//         setUploadLoading(false)
//     }

//     const videoHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products/video`, { fileName: file.name, fileType: file.type })
//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressVideoValue(progress)
//                         },
//                     })
//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                     }
//                 }
//             }
//         } catch (error) {
//             console.log(error);
//         }
//     }

//     const submit = async (e) => {
//         e.preventDefault()
//         setLoading(true)

//         if (ageGroupSelectedOptions.length === 0) {
//             setAgeGroupError(true);
//             errorRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
//             setLoading(false);
//             return;
//         }

//         if (!descriptionValue || !otherValue) {
//             Swal.fire("Description and Care Instructions are required!");
//             setLoading(false);
//             return;
//         }

//         if (!formValue.type) {
//             Swal.fire("Please select Product Type!");
//             setLoading(false);
//             return;
//         }

//         if (!formValue.subcategory) {
//             Swal.fire("Please select Sub Category!");
//             setLoading(false);
//             return;
//         }

//         const dataValue = {
//             ...formValue,
//             description: descriptionValue,
//             specification: specificationvalue,
//             keyFeature: keyvalue,
//             otherInfo: otherValue,
//             ageGroup: ageGroupSelectedOptions,
//             limitedEdition: isLimitedEdition,
//             salePrice: salePriceValue || formValue.salePrice,
//         };

//         try {
//             await axios.post(`${Url}/product/update/${id}`, dataValue)
//             Swal.fire({
//                 position: 'top-end',
//                 icon: 'success',
//                 title: 'Product Updated Successfully',
//                 showConfirmButton: false,
//                 timer: 1500
//             })
//             setLoading(false)
//             dispatch(productdata())
//             navigate("/dashboard/products")
//         } catch (error) {
//             Swal.fire({
//                 position: 'top-end',
//                 icon: 'error',
//                 title: error?.response?.data?.message || "Something Went Wrong",
//                 showConfirmButton: false,
//                 timer: 1500
//             })
//             console.log(error.message);
//             setLoading(false)
//         }
//     }

//     const editDataFilter = async () => {
//         try {
//             const productResponse = await axios.get(`${Url}/product/single-product/${id}`)
//             if (productResponse.status === 200) {
//                 const response = productResponse.data
//                 setFormValue({ ...response, ...response?.productSize })
//                 setSpecificationValue(response.specification)
//                 setOtherValue(response.otherInfo)
//                 setDescriptionValue(response.description)
//                 setKeyValue(response.keyFeature)
//                 setAgeGroupSelectedOptions(response.ageGroup || [])
//                 setIsLimitedEdition(response.limitedEdition || false)
//                 // existing sale price set karo
//                 setSalePriceValue(String(response.salePrice || ''))
//             }
//         } catch (error) {
//             console.log(error);
//             setApiErr(true)
//         }
//     }

//     useEffect(() => {
//         editDataFilter()
//     }, [id])

//     return (
//         <>
//             <Helmet>
//                 <title> Update Product </title>
//             </Helmet>

//             <Container>
//                 <div className="mb-4 text-primary">
//                     <h2 className="text-capitalize">Update Product</h2>
//                 </div>
//                 {productAllData && formValue ?
//                     <div className="p-3 bg-light rounded shadow border">
//                         <form action="" onSubmit={e => submit(e)}>
//                             <div className="row">

//                                 {/* Product Name */}
//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Product Name</p>
//                                         <input type="text" value={formValue.productName || ""} name="productName" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>

//                                 {/* Limited Edition */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Limited Edition</p>
//                                         <div className="form-check mt-1">
//                                             <input
//                                                 type="checkbox"
//                                                 className="form-check-input"
//                                                 id="limitedEditionUpdate"
//                                                 checked={isLimitedEdition}
//                                                 onChange={(e) => setIsLimitedEdition(e.target.checked)}
//                                             />
//                                             <span className="form-check-label ms-2">Mark as Limited Edition</span>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Short Description */}
//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Short Description</p>
//                                         <textarea className="form-control" value={formValue.shortDescription || ""} name="shortDescription" onChange={e => formHandle(e)} rows="3" required />
//                                     </div>
//                                 </div>

//                                 {/* Thumbnail */}
//                                 <div className="col-lg-6 col-12 mb-4">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Thumbnail Image</p>
//                                         <input type="file" name="thumbnailImage" onChange={e => thumbnailHandle(e)} className="form-control" />
//                                         <div className="d-flex justify-content-end gap-2 pt-2">
//                                             {uploadLoading && progressValue && <progress className="flex-grow-1" value={progressValue} max="100" style={{ height: "5px" }} />}
//                                         </div>
//                                     </div>
//                                     <div className="mt-2">
//                                         <img src={`${formValue?.thumbnailImage}`} alt="" style={{ width: "70px" }} className="border rounded" />
//                                     </div>
//                                 </div>

//                                 {/* Product Images */}
//                                 <div className="col-lg-6 col-12 mb-4">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Product Images</p>
//                                         <input type="file" name="images" multiple onChange={e => fileHandle(e)} className="form-control" />
//                                         {totalfiles !== 0 &&
//                                             <div className="d-flex justify-content-end gap-2 pt-2 align-items-center">
//                                                 <progress className="flex-grow-1" value={(totalUpload / totalfiles) * 100} max="100" style={{ height: "5px" }} />
//                                                 <small className="fs-10 text-secondary w-max-content">{totalUpload}/{totalfiles}</small>
//                                                 <small className="fs-10 text-success w-max-content">{((totalUpload / totalfiles) * 100).toFixed(1)}%</small>
//                                             </div>
//                                         }
//                                     </div>
//                                     <div className="mt-2 d-flex flex-wrap gap-3">
//                                         {formValue?.images?.map((cv, i) => (
//                                             <img key={i} src={`${cv}`} alt="" style={{ width: "70px" }} className="border rounded me-1 mb-1" />
//                                         ))}
//                                     </div>
//                                 </div>

//                                 {/* Video */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Product Video <span className="fw-normal text-secondary">(optional)</span></p>
//                                         <input type="file" name="video" accept="video/*" onChange={e => videoHandle(e)} className="form-control" />
//                                         <div className="d-flex justify-content-end gap-2 pt-2">
//                                             {progressVideoValue > 0 && progressVideoValue < 100 && (
//                                                 <progress className="flex-grow-1" value={progressVideoValue} max="100" style={{ height: "5px" }} />
//                                             )}
//                                             {progressVideoValue > 0 && (
//                                                 <small className="fs-10 text-success">
//                                                     {progressVideoValue < 100 ? `${progressVideoValue}%` : 'success'}
//                                                 </small>
//                                             )}
//                                         </div>
//                                     </div>
//                                     <div className="mt-2">
//                                         <video src={formValue?.video} controls muted width={150} />
//                                     </div>
//                                 </div>

//                                 {/* Alt Tag */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Image Alt Tag</p>
//                                         <input type="text" value={formValue.altTag || ""} name="altTag" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>

//                                 {/* MRP */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">MRP (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
//                                         <input type="number" value={formValue.mrp || ""} name="mrp" onChange={handleMrpOrDiscount} className="form-control" required onWheel={(e) => e.target.blur()} />
//                                     </div>
//                                 </div>

//                                 {/* Discount */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Discount (%) <span className="fw-normal text-secondary">(optional)</span></p>
//                                         <input type="number" value={formValue.discount || ""} name="discount" onChange={handleMrpOrDiscount} className="form-control" onWheel={(e) => e.target.blur()} />
//                                     </div>
//                                 </div>

//                                 {/* Sale Price */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">
//                                             Sale Price (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)
//                                             {salePriceValue && formValue.discount > 0 && (
//                                                 <span className="fw-normal text-success ms-2" style={{ fontSize: '12px' }}>✓ Auto-calculated</span>
//                                             )}
//                                         </p>
//                                         <input
//                                             type="number"
//                                             name="salePrice"
//                                             value={salePriceValue || formValue.salePrice || ""}
//                                             onChange={(e) => {
//                                                 setSalePriceValue(e.target.value);
//                                                 setFormValue({ ...formValue, salePrice: e.target.value });
//                                             }}
//                                             className="form-control"
//                                             required
//                                             onWheel={(e) => e.target.blur()}
//                                             placeholder="Discount daalne par auto fill hoga"
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* Height / Width / Depth / Unit */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="row">
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Height</p>
//                                                 <input type="text" name="height" value={formValue?.height || ""} onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Width</p>
//                                                 <input type="text" name="width" value={formValue?.width || ""} onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Depth</p>
//                                                 <input type="text" name="depth" value={formValue?.depth || ""} onChange={e => formHandle(e)} className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-3 col-md-6 mb-2">
//                                             <div className="form-group">
//                                                 <p className="mb-0 fw-bold">Unit</p>
//                                                 <select name="measurement" onChange={e => formHandle(e)} value={formValue?.measurement || ""} className="form-select" required>
//                                                     <option value="" disabled>Choose</option>
//                                                     <option value="cm">cm</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Total Product */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Total Product</p>
//                                         <input type="number" value={formValue.totalProduct || ""} name="totalProduct" onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
//                                     </div>
//                                 </div>

//                                 {/* Category */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Category</p>
//                                         <select name="category" value={formValue.category || ""} onChange={e => formHandle(e)} className="form-select" required>
//                                             <option value="" disabled>Category Choose</option>
//                                             {categoryAllData.map((cv, i) => (
//                                                 <option value={cv.category} key={i}>{cv.category}</option>
//                                             ))}
//                                         </select>
//                                     </div>
//                                 </div>

//                                 {/* Sub Category */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Sub Category</p>
//                                         <select name="subcategory" value={formValue?.subcategory || ""} onChange={e => formHandle(e)} className="form-select" required>
//                                             <option value="" disabled>Choose</option>
//                                             {formValue?.category && subcategoryAllData
//                                                 .filter(val => val.category === formValue.category)
//                                                 .map((value, i) => (
//                                                     <option value={value.subcategory} key={i}>{value.subcategory}</option>
//                                                 ))
//                                             }
//                                         </select>
//                                     </div>
//                                 </div>

//                                 {/* Type */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Type</p>
//                                         <select name="type" value={formValue.type || ""} onChange={e => formHandle(e)} className="form-select" required>
//                                             <option value="" disabled>Choose Type</option>
//                                             <option value="big">Big</option>
//                                             <option value="small">Small</option>
//                                         </select>
//                                     </div>
//                                 </div>

//                                 {/* Batch No */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Batch No.</p>
//                                         <input type="text" value={formValue.batch || ""} name="batch" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>

//                                 {/* SKU No */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">SKU No.</p>
//                                         <input type="text" value={formValue.sku || ""} name="sku" onChange={e => formHandle(e)} className="form-control" required />
//                                     </div>
//                                 </div>

//                                 {/* Replacement */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Replacement (days)</p>
//                                         <input type="number" name="replacement" value={formValue.replacement || ""} onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
//                                     </div>
//                                 </div>

//                                 {/* Weight */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Product Weight (gm)</p>
//                                         <input type="number" name="weight" value={formValue.weight || ""} onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
//                                     </div>
//                                 </div>

//                                 {/* Tags */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Choose Tags <span className="fw-normal text-secondary">(optional)</span></p>
//                                         <select name="tags" value={formValue.tags || ""} onChange={e => formHandle(e)} className="form-select">
//                                             <option value="">Choose Any Tag</option>
//                                             <option value="top picks">Top Picks</option>
//                                             <option value="new arrival">New Arrival</option>
//                                         </select>
//                                     </div>
//                                 </div>

//                                 {/* Age Group */}
//                                 <div className="col-lg-6 col-12 mb-2">
//                                     <p className="mb-0 fw-bold">Choose Product Age Group</p>
//                                     {ageGroupError && (
//                                         <p ref={errorRef} className="text-danger fw-normal mb-1">Please select at least one option!</p>
//                                     )}
//                                     {ageGroupOptions.map((option, index) => (
//                                         <div key={index} className="form-check">
//                                             <input
//                                                 type="checkbox"
//                                                 id={`update-${option}`}
//                                                 checked={ageGroupSelectedOptions.includes(option)}
//                                                 onChange={() => handleAgeGroupChange(option)}
//                                                 className="form-check-input"
//                                             />
//                                             <label htmlFor={`update-${option}`} className="form-check-label">{option}</label>
//                                         </div>
//                                     ))}
//                                 </div>

//                                 {/* Product Description */}
//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Product Description</p>
//                                         <div className="text-editor bg-white rounded">
//                                             <ReactQuill theme="snow" value={descriptionValue} onChange={setDescriptionValue} placeholder={"Write something awesome..."} />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Material */}
//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Material</p>
//                                         <div className="text-editor bg-white">
//                                             <EditorToolbar />
//                                             <ReactQuill theme="snow" value={keyvalue} onChange={setKeyValue} placeholder={"Write something awesome..."} modules={modules} formats={formats} />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Dimensions */}
//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Dimensions</p>
//                                         <div className="text-editor bg-white">
//                                             <ReactQuill theme="snow" value={specificationvalue} onChange={setSpecificationValue} placeholder={"Write something awesome..."} />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Care Instructions */}
//                                 <div className="col-12 mb-2">
//                                     <div className="form-group">
//                                         <p className="mb-0 fw-bold">Care Instructions</p>
//                                         <div className="text-editor bg-white">
//                                             <ReactQuill theme="snow" name="other_info" value={otherValue} onChange={setOtherValue} placeholder={"Write something awesome..."} />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Submit */}
//                                 <div className="col-12">
//                                     <div className="form-group text-end">
//                                         <button className="btn btn-primary" type="submit" disabled={loading || apiErr}>
//                                             {loading ? "Saving..." : "Update"}
//                                         </button>
//                                     </div>
//                                 </div>

//                             </div>
//                         </form>
//                     </div>
//                     : null}
//             </Container>
//         </>
//     )
// }

// export default UpdateProduct







import React, { useEffect, useRef, useState } from "react";
import { Helmet } from 'react-helmet-async';
import { Container } from "@mui/material";
import ReactQuill from 'react-quill';
import axios from "axios";
import Swal from 'sweetalert2';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { Url, awsFileUrl } from "../url/url";
import 'react-quill/dist/quill.snow.css';
import EditorToolbar, { modules, formats } from "../utils/EditorToolbar";
import "../App.css"
import { productdata } from "../redux/slice/product";

const ageGroupOptions = ['0-12 months', '1-2 years', '3+ years', '5+ years', '10+ years'];

const UpdateProduct = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()
    const categoryAllData = useSelector(store => store.category.data)
    const subcategoryAllData = useSelector(store => store.subcategory.data)
    const productAllData = useSelector(store => store.product.data)

    const [keyvalue, setKeyValue] = useState('');
    const [specificationvalue, setSpecificationValue] = useState("");
    const [otherValue, setOtherValue] = useState('');
    const [descriptionValue, setDescriptionValue] = useState("");
    const [loading, setLoading] = useState(false);
    const [formValue, setFormValue] = useState({})
    const [apiErr, setApiErr] = useState(false)

    const [salePriceValue, setSalePriceValue] = useState('');

    const [uploadLoading, setUploadLoading] = useState(false);
    const [progressValue, setProgressValue] = useState(0);
    const [uploadStatus, setUploadStatus] = useState(false);

    const [multipleFileProgress, setMultipleFileProgress] = useState(0)
    const [totalfiles, setTotalFiles] = useState(0)
    const [totalUpload, setTotalUpload] = useState(0)
    const [multipleFileStatus, setMultipleFileStatus] = useState(false)

    const [progressVideoValue, setProgressVideoValue] = useState(0)

    const [ageGroupSelectedOptions, setAgeGroupSelectedOptions] = useState([]);
    const [ageGroupError, setAgeGroupError] = useState(false);
    const errorRef = useRef(null);
    const [isLimitedEdition, setIsLimitedEdition] = useState(false);

    const handleAgeGroupChange = (option) => {
        setAgeGroupSelectedOptions((prev) =>
            prev.includes(option)
                ? prev.filter((item) => item !== option)
                : [...prev, option]
        );
    };

    const formHandle = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'category') {
            setFormValue({ ...formValue, subcategory: "", [name]: value });
        } else {
            setFormValue({ ...formValue, [name]: value });
        }
    }

    // MRP ya Discount change hone par Sale Price auto-calculate
    const handleMrpOrDiscount = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        const updated = { ...formValue, [name]: value };
        setFormValue(updated);

        const mrp = parseFloat(name === 'mrp' ? value : updated.mrp) || 0;
        const discountRaw = name === 'discount' ? value : updated.discount;
        const discount = parseFloat(discountRaw);

        if (!discountRaw || discountRaw === '' || Number.isNaN(discount) || discount <= 0) {
            setSalePriceValue('');
            setFormValue({ ...updated, salePrice: updated.salePrice || '' });
            return;
        }

        if (mrp > 0) {
            const calculated = String(Math.round(mrp - (mrp * discount) / 100));
            setSalePriceValue(calculated);
            setFormValue({ ...updated, salePrice: calculated });
        }
    };

    const fileHandle = async (e) => {
        const files = e.target.files;
        const name = e.target.name;
        const uploadedFiles = [];
        setTotalFiles(files?.length);
        setTotalUpload(0);
        setMultipleFileProgress(0);
        setMultipleFileStatus(true);
        try {
            await Array.from(files).reduce(async (previousPromise, file, i) => {
                await previousPromise;
                if (file) {
                    const response = await axios.post(`${Url}/api/createPresignedUrl/products`, { fileName: file.name, fileType: file.type });
                    if (response.status === 200) {
                        const { preSignedUrl, key } = response?.data;
                        const responseFileSave = await axios.put(preSignedUrl, file, {
                            onUploadProgress: (progressEvent) => {
                                const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setMultipleFileProgress(progress);
                            },
                        });
                        if (responseFileSave.status === 200) {
                            const fileUrl = `${awsFileUrl}/${key}`;
                            setTotalUpload(i + 1);
                            uploadedFiles.push(fileUrl);
                        } else {
                            throw new Error('File upload failed');
                        }
                    }
                }
            }, Promise.resolve());
            setFormValue({ ...formValue, [name]: uploadedFiles });
            setMultipleFileStatus(false);
            setUploadStatus(true);
        } catch (error) {
            console.log(error);
        } finally {
            setMultipleFileStatus(false);
            setProgressValue(0);
        }
    };

    const thumbnailHandle = async (e) => {
        const file = e.target.files[0]
        const name = e.target.name
        setUploadLoading(true)
        try {
            if (file) {
                const response = await axios.post(`${Url}/api/createPresignedUrl/products`, { fileName: file.name, fileType: file.type })
                if (response.status === 200) {
                    const { preSignedUrl, key } = response?.data
                    const responseFileSave = await axios.put(preSignedUrl, file, {
                        onUploadProgress: (progressEvent) => {
                            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            setProgressValue(progress)
                        },
                    })
                    if (responseFileSave.status === 200) {
                        const fileUrl = `${awsFileUrl}/${key}`
                        setFormValue({ ...formValue, [name]: fileUrl })
                        setUploadStatus(true)
                        setUploadLoading(false)
                        setProgressValue(0)
                    } else {
                        setUploadLoading(false)
                        setProgressValue(0)
                        setUploadStatus(false)
                    }
                    setUploadLoading(false)
                }
                setUploadLoading(false)
            }
        } catch (error) {
            console.log(error);
            setUploadLoading(false)
        }
        setUploadLoading(false)
    }

    const videoHandle = async (e) => {
        const file = e.target.files[0]
        const name = e.target.name
        try {
            if (file) {
                const response = await axios.post(`${Url}/api/createPresignedUrl/products/video`, { fileName: file.name, fileType: file.type })
                if (response.status === 200) {
                    const { preSignedUrl, key } = response?.data
                    const responseFileSave = await axios.put(preSignedUrl, file, {
                        onUploadProgress: (progressEvent) => {
                            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            setProgressVideoValue(progress)
                        },
                    })
                    if (responseFileSave.status === 200) {
                        const fileUrl = `${awsFileUrl}/${key}`
                        setFormValue({ ...formValue, [name]: fileUrl })
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    const submit = async (e) => {
        e.preventDefault()
        setLoading(true)

        if (ageGroupSelectedOptions.length === 0) {
            setAgeGroupError(true);
            errorRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            setLoading(false);
            return;
        }

        if (!descriptionValue || !otherValue) {
            Swal.fire("Description and Care Instructions are required!");
            setLoading(false);
            return;
        }

        if (!formValue.type) {
            Swal.fire("Please select Product Type!");
            setLoading(false);
            return;
        }

        if (!formValue.subcategory) {
            Swal.fire("Please select Sub Category!");
            setLoading(false);
            return;
        }

        const dataValue = {
            ...formValue,
            description: descriptionValue,
            specification: specificationvalue,
            keyFeature: keyvalue,
            otherInfo: otherValue,
            ageGroup: ageGroupSelectedOptions,
            limitedEdition: isLimitedEdition,
            salePrice: salePriceValue || formValue.salePrice,
        };

        try {
            await axios.post(`${Url}/product/update/${id}`, dataValue)
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Product Updated Successfully',
                showConfirmButton: false,
                timer: 1500
            })
            setLoading(false)
            dispatch(productdata())
            navigate("/dashboard/products")
        } catch (error) {
            Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: error?.response?.data?.message || "Something Went Wrong",
                showConfirmButton: false,
                timer: 1500
            })
            console.log(error.message);
            setLoading(false)
        }
    }

    useEffect(() => {
        if (productAllData && productAllData.length > 0) {
            const product = productAllData.find(p => p._id === id)
            if (product) {
                setFormValue({ ...product, ...product?.productSize })
                setSpecificationValue(product.specification || '')
                setOtherValue(product.otherInfo || '')
                setDescriptionValue(product.description || '')
                setKeyValue(product.keyFeature || '')
                setAgeGroupSelectedOptions(product.ageGroup || [])
                setIsLimitedEdition(product.limitedEdition || false)
                setSalePriceValue(String(product.salePrice || ''))
            }
        }
    }, [id, productAllData])

    return (
        <>
            <Helmet>
                <title> Update Product </title>
            </Helmet>

            <Container>
                <div className="mb-4 text-primary">
                    <h2 className="text-capitalize">Update Product</h2>
                </div>
                {productAllData && formValue ?
                    <div className="p-3 bg-light rounded shadow border">
                        <form action="" onSubmit={e => submit(e)}>
                            <div className="row">

                                {/* Product Name */}
                                <div className="col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Product Name</p>
                                        <input type="text" value={formValue.productName || ""} name="productName" onChange={e => formHandle(e)} className="form-control" required />
                                    </div>
                                </div>

                                {/* Limited Edition */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Limited Edition</p>
                                        <div className="form-check mt-1">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="limitedEditionUpdate"
                                                checked={isLimitedEdition}
                                                onChange={(e) => setIsLimitedEdition(e.target.checked)}
                                            />
                                            <span className="form-check-label ms-2">Mark as Limited Edition</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Short Description */}
                                <div className="col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Short Description</p>
                                        <textarea className="form-control" value={formValue.shortDescription || ""} name="shortDescription" onChange={e => formHandle(e)} rows="3" required />
                                    </div>
                                </div>

                                {/* Thumbnail */}
                                <div className="col-lg-6 col-12 mb-4">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Thumbnail Image</p>
                                        <input type="file" name="thumbnailImage" onChange={e => thumbnailHandle(e)} className="form-control" />
                                        <div className="d-flex justify-content-end gap-2 pt-2">
                                            {uploadLoading && progressValue && <progress className="flex-grow-1" value={progressValue} max="100" style={{ height: "5px" }} />}
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <img src={`${formValue?.thumbnailImage}`} alt="" style={{ width: "70px" }} className="border rounded" />
                                    </div>
                                </div>

                                {/* Product Images */}
                                <div className="col-lg-6 col-12 mb-4">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Product Images</p>
                                        <input type="file" name="images" multiple onChange={e => fileHandle(e)} className="form-control" />
                                        {totalfiles !== 0 &&
                                            <div className="d-flex justify-content-end gap-2 pt-2 align-items-center">
                                                <progress className="flex-grow-1" value={(totalUpload / totalfiles) * 100} max="100" style={{ height: "5px" }} />
                                                <small className="fs-10 text-secondary w-max-content">{totalUpload}/{totalfiles}</small>
                                                <small className="fs-10 text-success w-max-content">{((totalUpload / totalfiles) * 100).toFixed(1)}%</small>
                                            </div>
                                        }
                                    </div>
                                    <div className="mt-2 d-flex flex-wrap gap-3">
                                        {formValue?.images?.map((cv, i) => (
                                            <img key={i} src={`${cv}`} alt="" style={{ width: "70px" }} className="border rounded me-1 mb-1" />
                                        ))}
                                    </div>
                                </div>

                                {/* Video */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Product Video <span className="fw-normal text-secondary">(optional)</span></p>
                                        <input type="file" name="video" accept="video/*" onChange={e => videoHandle(e)} className="form-control" />
                                        <div className="d-flex justify-content-end gap-2 pt-2">
                                            {progressVideoValue > 0 && progressVideoValue < 100 && (
                                                <progress className="flex-grow-1" value={progressVideoValue} max="100" style={{ height: "5px" }} />
                                            )}
                                            {progressVideoValue > 0 && (
                                                <small className="fs-10 text-success">
                                                    {progressVideoValue < 100 ? `${progressVideoValue}%` : 'success'}
                                                </small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <video src={formValue?.video} controls muted width={150} />
                                    </div>
                                </div>

                                {/* Alt Tag */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Image Alt Tag</p>
                                        <input type="text" value={formValue.altTag || ""} name="altTag" onChange={e => formHandle(e)} className="form-control" required />
                                    </div>
                                </div>

                                {/* MRP */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">MRP (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
                                        <input type="number" value={formValue.mrp || ""} name="mrp" onChange={handleMrpOrDiscount} className="form-control" required onWheel={(e) => e.target.blur()} />
                                    </div>
                                </div>

                                {/* Discount */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Discount (%) <span className="fw-normal text-secondary">(optional)</span></p>
                                        <input type="number" value={formValue.discount || ""} name="discount" onChange={handleMrpOrDiscount} className="form-control" onWheel={(e) => e.target.blur()} />
                                    </div>
                                </div>

                                {/* Sale Price */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">
                                            Sale Price (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)
                                            {salePriceValue && formValue.discount > 0 && (
                                                <span className="fw-normal text-success ms-2" style={{ fontSize: '12px' }}>✓ Auto-calculated</span>
                                            )}
                                        </p>
                                        <input
                                            type="number"
                                            name="salePrice"
                                            value={salePriceValue || formValue.salePrice || ""}
                                            onChange={(e) => {
                                                setSalePriceValue(e.target.value);
                                                setFormValue({ ...formValue, salePrice: e.target.value });
                                            }}
                                            className="form-control"
                                            required
                                            onWheel={(e) => e.target.blur()}
                                            placeholder="Discount daalne par auto fill hoga"
                                        />
                                    </div>
                                </div>

                                {/* Height / Width / Depth / Unit */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="row">
                                        <div className="col-lg-3 col-md-6 mb-2">
                                            <div className="form-group">
                                                <p className="mb-0 fw-bold">Height</p>
                                                <input type="text" name="height" value={formValue?.height || ""} onChange={e => formHandle(e)} className="form-control" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-2">
                                            <div className="form-group">
                                                <p className="mb-0 fw-bold">Width</p>
                                                <input type="text" name="width" value={formValue?.width || ""} onChange={e => formHandle(e)} className="form-control" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-2">
                                            <div className="form-group">
                                                <p className="mb-0 fw-bold">Depth</p>
                                                <input type="text" name="depth" value={formValue?.depth || ""} onChange={e => formHandle(e)} className="form-control" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-2">
                                            <div className="form-group">
                                                <p className="mb-0 fw-bold">Unit</p>
                                                <select name="measurement" onChange={e => formHandle(e)} value={formValue?.measurement || ""} className="form-select" required>
                                                    <option value="" disabled>Choose</option>
                                                    <option value="cm">cm</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Total Product */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Total Product</p>
                                        <input type="number" value={formValue.totalProduct || ""} name="totalProduct" onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
                                    </div>
                                </div>

                                {/* Category */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Category</p>
                                        <select name="category" value={formValue.category || ""} onChange={e => formHandle(e)} className="form-select" required>
                                            <option value="" disabled>Category Choose</option>
                                            {categoryAllData.map((cv, i) => (
                                                <option value={cv.category} key={i}>{cv.category}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Sub Category */}
                         {/* Sub Category */}
<div className="col-lg-6 col-12 mb-2">
    <div className="form-group">
        <p className="mb-0 fw-bold">Sub Category</p>
        <select
            name="subcategory"
            value={formValue?.subcategory || ""}
            onChange={e => formHandle(e)}
            className="form-select"
            required
        >
            <option value="" disabled>Choose</option>
            {formValue?.category && subcategoryAllData
                // ✅ same fix
                .filter(val => {
                    const catId = val.category?._id || val.category
                    return catId === formValue.category || val.category?.category === formValue.category
                })
                .map((value, i) => (
                    <option value={value.subcategory} key={i}>
                        {value.subcategory}
                    </option>
                ))
            }
        </select>
    </div>
</div>

                                {/* Type */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Type</p>
                                        <select name="type" value={formValue.type || ""} onChange={e => formHandle(e)} className="form-select" required>
                                            <option value="" disabled>Choose Type</option>
                                            <option value="big">Big</option>
                                            <option value="small">Small</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Batch No */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Batch No.</p>
                                        <input type="text" value={formValue.batch || ""} name="batch" onChange={e => formHandle(e)} className="form-control" required />
                                    </div>
                                </div>

                                {/* SKU No */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">SKU No.</p>
                                        <input type="text" value={formValue.sku || ""} name="sku" onChange={e => formHandle(e)} className="form-control" required />
                                    </div>
                                </div>

                                {/* Replacement */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Replacement (days)</p>
                                        <input type="number" name="replacement" value={formValue.replacement || ""} onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
                                    </div>
                                </div>

                                {/* Weight */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Product Weight (gm)</p>
                                        <input type="number" name="weight" value={formValue.weight || ""} onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
                                    </div>
                                </div>

                                {/* Tags */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Choose Tags <span className="fw-normal text-secondary">(optional)</span></p>
                                        <select name="tags" value={formValue.tags || ""} onChange={e => formHandle(e)} className="form-select">
                                            <option value="">Choose Any Tag</option>
                                            <option value="top picks">Top Picks</option>
                                            <option value="new arrival">New Arrival</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Age Group */}
                                <div className="col-lg-6 col-12 mb-2">
                                    <p className="mb-0 fw-bold">Choose Product Age Group</p>
                                    {ageGroupError && (
                                        <p ref={errorRef} className="text-danger fw-normal mb-1">Please select at least one option!</p>
                                    )}
                                    {ageGroupOptions.map((option, index) => (
                                        <div key={index} className="form-check">
                                            <input
                                                type="checkbox"
                                                id={`update-${option}`}
                                                checked={ageGroupSelectedOptions.includes(option)}
                                                onChange={() => handleAgeGroupChange(option)}
                                                className="form-check-input"
                                            />
                                            <label htmlFor={`update-${option}`} className="form-check-label">{option}</label>
                                        </div>
                                    ))}
                                </div>

                                {/* Product Description */}
                                <div className="col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Product Description</p>
                                        <div className="text-editor bg-white rounded">
                                            <ReactQuill theme="snow" value={descriptionValue} onChange={setDescriptionValue} placeholder={"Write something awesome..."} />
                                        </div>
                                    </div>
                                </div>

                                {/* Material */}
                                <div className="col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">key Features</p>
                                        <div className="text-editor bg-white">
                                            <EditorToolbar />
                                            <ReactQuill theme="snow" value={keyvalue} onChange={setKeyValue} placeholder={"Write something awesome..."} modules={modules} formats={formats} />
                                        </div>
                                    </div>
                                </div>

                                {/* Dimensions */}
                                <div className="col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Specifications</p>
                                        <div className="text-editor bg-white">
                                            <ReactQuill theme="snow" value={specificationvalue} onChange={setSpecificationValue} placeholder={"Write something awesome..."} />
                                        </div>
                                    </div>
                                </div>

                                {/* Care Instructions */}
                                <div className="col-12 mb-2">
                                    <div className="form-group">
                                        <p className="mb-0 fw-bold">Other Information</p>
                                        <div className="text-editor bg-white">
                                            <ReactQuill theme="snow" name="other_info" value={otherValue} onChange={setOtherValue} placeholder={"Write something awesome..."} />
                                        </div>
                                    </div>
                                </div>

                                {/* Submit */}
                                <div className="col-12">
                                    <div className="form-group text-end">
                                        <button className="btn btn-primary" type="submit" disabled={loading || apiErr}>
                                            {loading ? "Saving..." : "Update"}
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                    : null}
            </Container>
        </>
    )
}

export default UpdateProduct